
<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row mt-1" v-for="(el, index) in getData()">
        <div class="col-12">
          <input-select3 class="mt-1" v-model="el.DiagramType" v-bind:options="['Pie','Line','Dash','Bar']" />
          <input-select3 class="mt-1" v-if="el.DiagramType == 'Bar'" v-model="el.DiagramSource" v-bind:options="['User','Priority','Status','Location','Value','UserAndStatus']" />
          <input-select3 class="mt-1" v-if="el.DiagramType != 'Dash' && el.DiagramType != 'Bar' && el.DiagramType != 'Pie'" v-model="el.DiagramSource" v-bind:options="['User','Priority','Status','Location','Value','ProcedureType']" />
          <input-select3 class="mt-1" v-if="el.DiagramType == 'Pie'" v-model="el.DiagramSource" v-bind:options="pieOptions" />
          <input-select3 class="mt-1" v-if="el.DiagramType == 'Dash'" v-model="el.DiagramSource" v-bind:options="['ActiveUsers','TasksCreated','TasksDone','CPU','Memory','ThreadsCreated','Efficiency','TasksNotDone']" />
          <input-select3 class="mt-1" v-if="el.DiagramSource == 'Value'" v-model="el.DiagramDataSource" v-bind:options="values" />
          <input type="text" class="form-control ml-1 px-1 col-3" v-model="el.Name" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />

          <a href="#" @click="remove(el)"><i class="icon-subtract"></i></a>

        </div>
      </div>

    </div>
    <diagram-add ref="diagramAdd" v-bind:procedureid="procedureid" v-if="showadd == true" @add="addItem" />
  </div>
</template>

<script>

  export default {
    name: 'diagram-element',
    components: {
    },
    data() {
      return {
        contentJson: "",
        elements: ['olle', 'bertil'],
        pieOptions: ['User', 'Priority', 'Status', 'Location', 'Value', 'ProcedureType'],
      }
    },
    props: {
      procedureid: {
        required: false,
        type: Number,
        default: -1,
      },
      value: {
        required: false,
        type: Array,
        default() {
          return []
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      showadd: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
      showcontrols: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
      allownesting: {
        required: false,
        type: Boolean,
        default() {
          return false
        }
      },
    },
    methods: {
      getProcElements(procedureId) {
        //GetProcedureDetail(int procedureId, string date, int? procedureScheduleId)
        try {
          this.$http.get('/api/Procedures/v1/GetProcedureElements?procedureId=' + procedureId).then(async response => {
            var subtasksresponse = response.data;
            console.log(subtasksresponse);
            for (var i = 0; i < subtasksresponse.length; i++) {
              if (subtasksresponse[i].ElementType == 6 ||
                subtasksresponse[i].ElementType == 8) {
                var val = "Ext_" + subtasksresponse[i].Text;
                if (this.pieOptions.indexOf(val) == -1) { // doesn't exists yet
                  this.$refs.diagramAdd.updateElement(val);
                  this.pieOptions.push(val);
                }
              }
            }
            // Filter those subtasks that we are interested in..
            //this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      setProcedure(procedureid) {
        this.procedureid = procedureid;
        this.getProcElements(procedureid);
      },
      getJsonData() {
        this.contentJson = JSON.stringify(this.realValue);
        return this.contentJson;
      },
      setJsonData() {
        this.value = JSON.parse(this.contentJson);
      },
      remove(el) {
        var elements = this.value;
        var itemIndex = -1;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i] == el) {
            itemIndex = i;
          }
        }
        this.realValue.splice(itemIndex, 1);
        this.$emit('change');
      },
      addChildItem(el) {
        if (!this.realValue.Series || this.realValue.Series == null)
          this.realValue.Series = [];
        this.realValue.Series.push(el);
        this.$forceUpdate();
      },
      addItem(el) {
        el.Series = [];
        this.realValue.push(el);
        this.$forceUpdate();
        this.$emit('change');
      },
      changed(el) {
        this.$forceUpdate();
        this.$emit('change');
      },
      setData(data) {
        this.value = data;
        this.$forceUpdate();
      },

      getData(data) {
        return this.value;
      },
      handleRefresh(val) {
        //this.elements = this.getFlat(val.Elements);

        //Vue.set(this, "elements", this.elements);
        //this.$forceUpdate();
      },
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
    mounted() {

    },

    computed: {
      /*
      elements: {
        get() {
          var proc = this.procedure;
          var els = this.getFlat(proc.Elements);
          return els;
        },
      },
      */
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 3");
          this.$store.commit('saveprocedure', value)
        }
      },
      realValue() {
        return this.value;
      },
      values() {
        //if (this.procedureid == -1)
        return ['test 1', 'test 2'];
      },
    },
    watch: {
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/statistics/diagram-element.vue